import React from "react";
import Icon from "../shared/Icon";
import { withTranslation } from "react-i18next";

/**
 * Écran encore sans maquette.
 *
 * Les entrées de navigation sont déjà présentes dans le design fourni ; plutôt
 * qu'un lien mort, on affiche ce que la page couvrira. Chaque écran remplace
 * ce composant à réception de sa maquette.
 */
const ComingSoon = ({ t, title, description }) => (
  <>
    <div className="mgr-head">
      <h1 className="mgr-h1">{t(title)}</h1>
    </div>
    <div className="mgr-card">
      <div className="mgr-state" style={{ padding: "64px 24px" }}>
        <Icon
          name="construct-outline"
          style={{ fontSize: 34, color: "var(--mgr-brand)", marginBottom: 14 }}
        />
        <div className="mgr-state-title">{t("Binnenkort beschikbaar")}</div>
        <div style={{ maxWidth: 460, margin: "0 auto" }}>{t(description)}</div>
      </div>
    </div>
  </>
);

export default withTranslation()(ComingSoon);
